import { render, staticRenderFns } from "./LayoutLeft.vue?vue&type=template&id=2c649d5a&scoped=true"
import script from "./LayoutLeft.vue?vue&type=script&lang=js"
export * from "./LayoutLeft.vue?vue&type=script&lang=js"
import style0 from "./LayoutLeft.vue?vue&type=style&index=0&id=2c649d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c649d5a",
  null
  
)

export default component.exports